import { render, staticRenderFns } from "./pages_tools.vue?vue&type=template&id=06fa3f68"
import script from "./pages_tools.vue?vue&type=script&lang=js"
export * from "./pages_tools.vue?vue&type=script&lang=js"
import style0 from "./pages_tools.vue?vue&type=style&index=0&id=06fa3f68&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports